<template>
  <div>
    <div v-if="elementName.length">
      <span
        v-if="elementName.length<10"
        class="ellipsis"
      >
      {{elementName}}
    </span>
      <el-tooltip
        v-if="elementName.length>=10"
        :content="elementName"
        placement="bottom"
        effect="light"
      >
        <span class="ellipsis">{{elementName}}</span>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
  import {checkNull} from "../../../filters/filters";
  export default {
    name:'my-listBox-tc',
    props:['transmitData'],
    data(){
      return{
        elementName:''
      }
    },
    created() {
      this.getElement();
    },
    methods:{
      getElement(){
        if(!checkNull(this.transmitData)){
          this.elementName = this.transmitData
        }
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/my-listBox-tc/src/main.vue